<template>
    <div class="editor" v-html="returnTextArea(termsText)"></div>
</template>

<script>
    import termsUtil from "@/components/terms/termsUtil";
    import util from "@/mixins/util";

    export default {
        name: "TermsComponent",
        mixins: [termsUtil],
        components: {},
        props: {
            termsType: {}

        },
        data() {
            return {
                termsKey: '',
                termsText: '',
                divisionType:'',

            }
        },
        beforeRouterEnter() {
        },
        created() {
            this.initConfig();
            this.getTerms();
            },
        mounted() {

        },
        beforeDestroy() {
        },
        destroyed() {
        },
        computed: {},
        methods: {
            initConfig() {
                let termsConfig = this.returnTermsConfig(this.termsType);
                this.termsKey = termsConfig.termsKey;
                this.divisionType = termsConfig.divisionType
            },
            getTerms() {
                let params = {
                    ty: this.divisionType,
                }
                try {
                    this.$api.$config.getConfig(params).then(res => res.Data.Result).then(res => {
                        if(res.Info.type != 1) {
                            return false;
                        }
                        let config = res.List[0];
                         this.termsText = util.htmlDecode(config[this.termsKey])
                    })

                }catch (e) {
                    console.log(e)
                }
            },
            returnTextArea(text){
                if(util.isEmpty(text)) {
                    return ''
                }
                return text.replace(/(\n|\r\n)/g, '<br>');
            }
        },
        watch: {},
    }
</script>

<style lang="scss">
.editor{
    *{
        max-width: 100%;
    }
}
</style>